import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable } from 'rxjs';
import { ApiClientService } from '@services/api-client/api-client.service';
import { CachedValuesService } from '@services/cached-values/cached-values.service';
import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { MoveLocationModalData } from './move-location-modal.model';

@Component({
    selector: 'app-move-location-modal',
    templateUrl: './move-location-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MoveLocationModalComponent {
    private readonly modal = inject(NgbActiveModal);
    private readonly apiClientService = inject(ApiClientService);
    private readonly cachedValuesService = inject(CachedValuesService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public data: MoveLocationModalData;
    public selectedLocationId: string | null = null;
    public isSaving = false;

    public readonly locationItems$: Observable<DropdownItem<string>[]> = this.cachedValuesService.locations$.pipe(
        map((locations) =>
            locations.map((location) => ({
                label: location.name,
                value: location.id
            }))
        )
    );

    public onCancel(): void {
        this.modal.dismiss();
    }

    public onConfirm(): void {
        if (!this.selectedLocationId) {
            return;
        }

        this.isSaving = true;
        this.changeDetectorRef.markForCheck();

        this.apiClientService
            .moveMeasurements$({ measurementIds: this.data.measurementIds, locationId: this.selectedLocationId })
            .subscribe({
                next: () => {
                    this.modal.close(true);
                },
                error: () => {
                    this.isSaving = false;
                    this.changeDetectorRef.markForCheck();
                    this.modal.close(false);
                }
            });
    }
}
